import { Button, useDeviceType } from '@cian/ui-kit';
import * as style from './RedBanner.css';
import { clsx } from 'clsx';

interface IRedBannerProps {
  onChangeModalVisible: VoidFunction;
}

export const RedBanner: React.FC<IRedBannerProps> = ({ onChangeModalVisible }) => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['text-block']}>
        <div className={style['item']}>
          <div className={style['number']}>90 000</div>
          <div className={style['title']}>Показов провели</div>
        </div>
        <div className={style['item']}>
          <div className={style['number']}>25 000</div>
          <div className={style['title']}>Квартир сдали</div>
        </div>
      </div>
      <div className={style['btn-container']}>
        <div className={style['logo-pik']} />
        <div className={style['btn']}>
          <Button fullWidth theme="fill_white_primary" size="L" onClick={onChangeModalVisible}>
            Позвоните мне
          </Button>
        </div>
      </div>
    </div>
  );
};
